import FieldDescription from "../tools/FieldDescription";
import PostalCodeField from "./PostalCodeField";
import { civilities } from "../../static/types/commonTypes/legalEntityType"
import useValidation from "../../hooks/useValidation";
import { useEffect, useState } from "react";
import { LegalEntityType, LegalEntityTypeOfficiant } from "../../static/types/commonTypes/legalEntityType";
import OfficiantValidationSchema from "../../utils/validation/officiantValidationSchema";
import { DateType } from "../../static/types/commonTypes/dateType";
import { format, parse, isValid } from "date-fns";
import DateComponent from "./DateComponent";
import useAppContext from "../../hooks/useAppContext";
import { AppContextType } from "../../context/AppContext";

type NotaireOfficiantProps = {
    checkedofficiant: boolean,
    legalEntityofficiant: LegalEntityTypeOfficiant,
    decisionNatureOptions: string[],
    societyType?: string | string[],
    changeLegalEntityofficiant: (data: Partial<LegalEntityTypeOfficiant>) => void,
    onValidationChangeofficiant: (isValid: boolean) => void
}

export default function Officiant({
    checkedofficiant,
    legalEntityofficiant,
    societyType,
    changeLegalEntityofficiant,
    decisionNatureOptions,
    onValidationChangeofficiant,
}: NotaireOfficiantProps) {

    const {
        dateNotary, setdateNotary,
        dateValidityNotary, setdateValidityNotary,
        dateCheckedNotary, setdateCheckedNotary,
    } = useAppContext() as AppContextType

    const updateDate = (data: Partial<DateType>) => setdateNotary({ ...dateNotary, ...data })

    const { errors, isValid: isDataValid } = useValidation(legalEntityofficiant, OfficiantValidationSchema);
    const legalFormOptions = Array.isArray(societyType) ? societyType : [societyType];
    useEffect(() => {
        changeLegalEntityofficiant({ ...legalEntityofficiant, decisionNature: decisionNatureOptions[0] });
    }, []);

    useEffect(() => {
        onValidationChangeofficiant(isDataValid)
    }, [isDataValid, onValidationChangeofficiant])

    return (

        <div className="mb-3 row">

            <div className="mb-3 row">
                <label htmlFor="decisionNature" className="col-sm-2 col-form-label">
                    Mode d'exercice
                </label>

                <div className="col-sm-4 mb-3">
                    <select
                        className={`form-select ${(checkedofficiant && errors.mode) ? 'is-invalid' : ''}`}
                        id="mode"
                        onChange={event => changeLegalEntityofficiant({ decisionNature: event.target.value })}
                        value={legalEntityofficiant.decisionNature}
                    >
                        {decisionNatureOptions.map(option => (
                            <option key={option} value={option}>{option}</option>
                        ))}
                    </select>
                    {(checkedofficiant && errors.mode) && (
                        <div className="invalid-feedback">{errors.mode}</div>
                    )}
                </div>
                <label htmlFor="sociteChoice" className="col-sm-2 col-form-label"> Forme juridique <strong className="text-danger">*</strong>  </label>

                <div className='col-sm-4'>
                    <select
                        className={`form-select ${(checkedofficiant && errors.legalForm) ? 'is-invalid' : ''}`}
                        name="legalForm"
                        id="legalForm"
                        onChange={event => changeLegalEntityofficiant({ legalForm: event.target.value })}
                        value={legalEntityofficiant.legalForm}
                    >
                        {
                            legalFormOptions.map((option, index) =>
                                <option key={index} value={option}>
                                    {option}
                                </option>
                            )
                        }
                    </select>
                    {(checkedofficiant && errors.legalForm) && <div className="invalid-feedback"> {errors.legalForm} </div>}
                </div>

                <label htmlFor="Denomination" className="col-sm-2 col-form-label required"> Dénomination  <strong className="text-danger">*</strong>  </label>

                <div className="col-sm-4">
                    <input
                        className={`description-input form-control ${(checkedofficiant && errors.Denomination) ? 'is-invalid' : ''}`}
                        type="text"
                        name="Denomination"
                        id="Denomination"
                        value={legalEntityofficiant.Denomination}
                        onChange={event => changeLegalEntityofficiant({ Denomination: event.target.value })}
                    />
                    {(checkedofficiant && errors.Denomination) && <div className="invalid-feedback"> {errors.Denomination} </div>}
                </div>

                <label htmlFor="civility" className="col-sm-2 col-form-label"> Civilité <strong className="text-danger">*</strong>  </label>

                <div className="col-sm-4">

                    <select
                        className={`form-select ${(checkedofficiant && errors.civility) ? 'is-invalid' : ''}`}
                        name="civility"
                        id="civility"
                        value={legalEntityofficiant.civility}
                        onChange={event => changeLegalEntityofficiant({ civility: event.target.value as "Monsieur" | "Madame" })}
                    >
                        {
                            civilities.map(option =>
                                <option key={option} value={option}>
                                    {option}
                                </option>
                            )
                        }

                    </select>
                    {(checkedofficiant && errors.civility) && <div className="invalid-feedback"> {errors.civility} </div>}

                </div>

            </div>
            <div className="mb-3 row">
                <label htmlFor="nom" className="col-sm-2 col-form-label">Nom<strong className="text-danger">*</strong>  </label>

                <div className="col-sm-4">
                    <input
                        className={`form-control ${(checkedofficiant && errors.nom) ? 'is-invalid' : ''}`}
                        type="text"
                        name="nom"
                        id="nom"
                        value={legalEntityofficiant.nom}
                        onChange={event => changeLegalEntityofficiant({ nom: event?.target.value })}
                    />
                    {(checkedofficiant && errors.address) && <div className="invalid-feedback"> {errors.address} </div>}
                </div>

                <label htmlFor="prenom" className="col-sm-2 col-form-label">Prenom<strong className="text-danger">*</strong>  </label>
                <div className="col-sm-4">
                    <input
                        className={`form-control ${(checkedofficiant && errors.prenom) ? 'is-invalid' : ''}`}
                        type="text"
                        name="prenom"
                        id="prenom"
                        value={legalEntityofficiant.prenom}
                        onChange={event => changeLegalEntityofficiant({ prenom: event?.target.value })}
                    />
                    {(checkedofficiant && errors.address) && <div className="invalid-feedback"> {errors.address} </div>}
                </div>



            </div>

            <div className="mb-3 row">
                <label htmlFor="address" className="col-sm-2 col-form-label">Adresse <strong className="text-danger">*</strong>  </label>
                <div className="col-sm-4">
                    <input
                        className={`form-control ${(checkedofficiant && errors.address) ? 'is-invalid' : ''}`}
                        type="text"
                        name="address"
                        id="address"
                        value={legalEntityofficiant.address}
                        onChange={event => changeLegalEntityofficiant({ address: event?.target.value })}
                    />
                    {(checkedofficiant && errors.address) && <div className="invalid-feedback"> {errors.address} </div>}
                </div>

                <label htmlFor="additionalAddress" className="col-sm-2 col-form-label">Adresse suite </label>
                <div className="col-sm-4">
                    <input
                        className="form-control"
                        type="text"
                        name="additionalAddress"
                        id="additionalAddress"
                        value={legalEntityofficiant.additionalAddress}
                        onChange={event => changeLegalEntityofficiant({ additionalAddress: event.target.value })}
                    />
                </div>
            </div>

            <div className="mb-3 row">
                <PostalCodeField
                    checked={checkedofficiant}
                    onChange={(partialData: Partial<LegalEntityTypeOfficiant>) => changeLegalEntityofficiant({ ...legalEntityofficiant, ...partialData })}
                    postalCode={legalEntityofficiant.postalCode}
                    errors={errors}
                />

                <label htmlFor="city" className="col-sm-2 col-form-label"> Ville <strong className="text-danger">*</strong>  </label>
                <div className="col-sm-4">
                    <select
                        className={`form-control ${(checkedofficiant && errors.city) ? 'is-invalid' : ''}`}
                        name="city"
                        id="city"
                        onChange={event => changeLegalEntityofficiant({ city: event.target.value })}
                        value={legalEntityofficiant.city}
                    >
                        {
                            legalEntityofficiant.cities?.map((city, key) =>
                                <option key={key} value={city}>
                                    {city}
                                </option>
                            )
                        }
                    </select>
                    {(checkedofficiant && errors.city) && <div className="invalid-feedback"> {errors.city} </div>}
                </div>

            </div>
         
                <DateComponent
                    checked={dateCheckedNotary}
                    changeDate={updateDate}
                    date={dateNotary}
                    draftFieldName = "dateNotary"
                    dateLabel="Date de reception"
                    onValidationChange={(isValid: boolean) => setdateValidityNotary(isValid)}
                    required={true}
                    id="dateReceptionNotary"
                />
        
        </div>
    )
}